import { ReactNode, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import ConfiguringLoader from './ConfiguringLoader';

interface ProtectedRouteProps {
    children: ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);
    const location = useLocation();
    const wasAuthenticated = useRef(false);

    if (authStatus === 'authenticated') {
        wasAuthenticated.current = true;
    }

    if (authStatus === 'configuring') {
        // Shared bounded loader (issue #2595): spinner first, then a manual
        // "Sign in" escape hatch if configuring persists. This is the COMMON
        // stuck-spinner site — an idle user on /dashboard lands here.
        return <ConfiguringLoader />;
    }

    if (authStatus !== 'authenticated') {
        // Only mark as session-expired if the user was previously authenticated in this session
        const sessionExpired = wasAuthenticated.current;
        return <Navigate to="/login" state={{ from: location, sessionExpired }} replace />;
    }

    return <>{children}</>;
}

export default ProtectedRoute;
